import useFilters from '../../../hook/useFilters'
import {useAppSelector} from '../../../redux/useTypedSelector'
import useApi from '../../../services/useApi'
import {parseSalesRepReportData} from '../utils'

const useGetSalesRepReport = () => {
  const Api = useApi()
  const {user} = useAppSelector((state) => state.auth)

  const initialFilters = {
    search: '',
    sort_by: 'total/-1',
    filter_rep_email: user?.is_representative ? user?.username : '',
  }

  const {filters, onSearch, onSortingChange, setMultipleFilters} = useFilters(initialFilters, {
    sortType: 'number',
  })

  const {data: response, isFetching} = Api.useGetQuery('/products/inquiries/sales-rep-report', {
    filters: filters,
  })

  const onSalesRepFilterChange = (email: string) => {
    setMultipleFilters({
      filter_rep_email: email,
    })
  }

  return {
    salesRepData: parseSalesRepReportData(response?.data || []),
    isLoading: isFetching,
    filters,
    searchValue: filters.search,
    onSearch,
    onSortingChange,
    onSalesRepFilterChange,
  }
}

export default useGetSalesRepReport
